// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Hooks
import { useLocationData } from "../../hooks/use-location-data"

// ** Custom Components
import Box from "../../components/Box"
import Container from "../../components/Container"
import Heading from "../../components/Heading"
import Text from "../../components/Text"

const SectionContactLocation = () => {
  const { location } = useLocationData()

  const sortedLocations = location?.nodes?.reduce((acc: any, element: any) => {
    if (element.headOffice) {
      return [element, ...acc]
    }
    return [...acc, element]
  }, [])

  return (
    <Box>
      <Box className="bg-gray-75 p-6 lg:p-[74px]">
        <Container constrainedToBreakPoint className="relative pb-10">
          <Box className="flex flex-wrap gap-x-5 gap-y-9 lg:gap-y-[75px] justify-center">
            {sortedLocations.map((location: any) => (
              <Box key={location.id} className="max-w-[392px]">
                <Box className="rounded-lg isolate overflow-hidden mb-7">
                  <GatsbyImage
                    image={location.image?.asset?.gatsbyImageData}
                    alt="image office"
                  />
                </Box>
                <Box className="mb-7">
                  <Heading className="text-blue-500 text-center" as="h4">
                    {location.name}
                  </Heading>
                  <Text className="text-center text-orange-500">
                    License # {location.license}
                  </Text>
                </Box>
                <Box className="flex justify-center">
                  <Text className="text-center text-gray-700 max-w-[75%]">
                    {`${location.address}, ${location.address2 ? location.address2 + ', ' : ''} ${location.city}, ${location.province}, Canada ${location.postal}`}
                  </Text>
                </Box>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  )
}

export default SectionContactLocation
